// Library imports
import { Col, Container, Row } from "react-bootstrap";
import { PulseLoader } from "react-spinners";

// Design imports
import "../style.css";

/**
 * Loading Component
 *
 * A reusable loading indicator with customizable message.
 * Displays a pulse loader animation with text below it.
 *
 * @param {string} message - The loading message to display (default: "Loading...")
 * @returns {JSX.Element} Loading UI with spinner and message
 */
export default function Loading({ message = "Loading..." }) {
	return (
		<Container className="register-loading-container">
			{/* Spinner Row - Centered pulse loader animation */}
			<Row className="pb-5">
				<Col className="align-items-center d-flex justify-content-center">
					<PulseLoader color="#0061AF" loading={true} size={25} speedMultiplier={0.8} />
				</Col>
			</Row>

			{/* Message Row - Dynamic loading text based on context */}
			<Row className="align-items-center d-flex justify-content-center">
				<Col className="text-center">
					<label className="register-loading-container-text">{message}</label>
				</Col>
			</Row>
		</Container>
	);
}
